import { useQuery, useMutation } from "@tanstack/react-query";
import EmployerUpdateRequestService from "@/services/employer-update-request/employer-update-request.service";
import type {
  EmployerUpdateRequestSubmissionDto,
  EmployerUpdateRequestPreCheckResponse,
} from "@/models/dto/employer-update-request.dto";
import type { BaseResponse } from "@/models/responses/base/baseResponse.response";

export const useEmployerUpdateRequestPreCheck = (
  employerCode: string | undefined,
  options?: { enabled?: boolean }
) => {
  return useQuery<EmployerUpdateRequestPreCheckResponse, Error>({
    queryKey: ["employer-update-request-pre-check", employerCode],
    queryFn: () =>
      EmployerUpdateRequestService.preCheck(employerCode as string),
    enabled: !!employerCode && (options?.enabled ?? true),
    retry: false,
  });
};

export const useSubmitEmployerUpdateRequest = (authenticated: boolean) => {
  return useMutation<
    BaseResponse<{ id: string; status: string }>,
    Error,
    EmployerUpdateRequestSubmissionDto
  >({
    mutationFn: (dto) =>
      EmployerUpdateRequestService.submit(dto, authenticated),
  });
};
